import { filter, forEach, get, isEmpty, isNil } from 'lodash'

const groupOwnerIngredientsByComponentIngredientId = flatIngredientTree => {
  const ingredientsWithComponents = filter(
    flatIngredientTree,
    ({ componentIngredients }) => !isEmpty(componentIngredients),
  )

  const result = {}

  forEach(ingredientsWithComponents, ingredient =>
    forEach(ingredient.componentIngredients, componentIngredient => {
      if (!isNil(get(result, componentIngredient.id))) {
        result[componentIngredient.id].push(ingredient)
      } else {
        result[componentIngredient.id] = [ingredient]
      }
    }),
  )

  return result
}

export default groupOwnerIngredientsByComponentIngredientId
